// Chi ti accompagna — Founder Eliza in evidenza + 3 insegnanti in griglia intima.
// Testi editabili via /admin/landing-config.
import { useLandingConfig } from "@/hooks/useLandingConfig";
import SafeImg from "@/components/landing/SafeImg";

const DEFAULT_FOUNDER_PHOTO = "https://thb.tildacdn.net/tild6331-6234-4662-a435-303438316539/-/resize/1200x/IMG_1724.JPG";

const DEFAULT_TEAM = [
  {
    name: "Livia Borselli",
    image: "https://thb.tildacdn.net/tild6164-3033-4165-a637-656636323030/-/resize/600x/2.jpg",
    desc: "Senior · Gravidanza · Matwork · Reformer",
  },
  {
    name: "Emanuela Bagnardi",
    image: "https://thb.tildacdn.net/tild3464-6566-4337-b932-633230333033/-/resize/600x/3.jpg",
    desc: "Matwork · Reformer",
  },
];

export default function LandingTeam() {
  const { T, cfg } = useLandingConfig();
  const eyebrow = T("texts.team.eyebrow", "Chi ti accompagna");
  const founderPhoto = T("images.team_photo", "");
  const founderName1 = T("texts.team.founder_name_line1", "Eliza Ana");
  const founderName2 = T("texts.team.founder_name_line2", "Muresan");
  const founderRoleLabel = T("texts.team.founder_role_label", "Founder · Head Trainer");
  const founderParagraph1 = T(
    "texts.team.founder_paragraph1",
    "Epic Flow nasce dalla sua visione: rendere il Pilates accessibile, sicuro e davvero efficace per ogni fase della vita."
  );
  const founderParagraph2 = T(
    "texts.team.founder_paragraph2",
    "Tecnica, ascolto, personalizzazione. Con specializzazioni terapeutiche in coxoartrosi, fibromialgia, lombalgia, osteoporosi e pavimento pelvico."
  );
  const teamIntroTitle = T("texts.team.intro_title", "Insieme a Livia e Emanuela.");
  const cmsMembers = Array.isArray(cfg?.texts?.team?.members) && cfg.texts.team.members.length > 0
    ? cfg.texts.team.members
    : DEFAULT_TEAM;

  return (
    <section data-testid="landing-team" className="relative bg-muted/40">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-32 md:py-40">
        <div className="text-[10px] uppercase tracking-[0.42em] text-foreground/50 mb-16 md:mb-20 flex items-center gap-3">
          <span className="w-10 h-px bg-foreground/40" />
          {eyebrow}
        </div>

        {/* Founder Eliza — hero */}
        <div className="grid md:grid-cols-12 gap-12 md:gap-16 items-center mb-32">
          <div className="md:col-span-5 lg:col-span-4">
            <div className="aspect-[3/4] overflow-hidden rounded-[2rem]">
              <SafeImg
                src={founderPhoto}
                fallback={DEFAULT_FOUNDER_PHOTO}
                alt={`${founderName1} ${founderName2}`}
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="md:col-span-7 lg:col-span-8 md:pl-6">
            <div className="text-[10px] uppercase tracking-[0.32em] text-mauve mb-4">{founderRoleLabel}</div>
            <h3 className="font-serif-display font-normal text-6xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight text-foreground">
              {founderName1}
              <br />
              <span className="font-editorial text-mauve">{founderName2}</span>
            </h3>
            <p className="mt-10 text-lg md:text-xl leading-relaxed text-foreground/75 max-w-2xl font-light">
              {founderParagraph1}
            </p>
            <p className="mt-6 text-base leading-relaxed text-foreground/60 max-w-2xl font-light">
              {founderParagraph2}
            </p>
          </div>
        </div>

        {/* Divider elegante */}
        <div className="w-16 h-px bg-mauve mx-auto mb-20" />

        {/* Altre insegnanti — editabili da CMS */}
        <div className="text-center mb-16">
          <div className="font-serif-display text-3xl md:text-4xl text-foreground">
            {teamIntroTitle}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 md:gap-16 max-w-3xl mx-auto justify-items-center">
          {cmsMembers.map((t, i) => (
            <div key={`${t?.name || "member"}-${i}`} data-testid={`team-card-${i}`} className="text-center">
              <div className="aspect-square overflow-hidden rounded-full max-w-[240px] mx-auto mb-6">
                <SafeImg
                  src={t?.image}
                  fallback={DEFAULT_TEAM[i % DEFAULT_TEAM.length]?.image}
                  alt={t?.name || `Insegnante ${i + 1}`}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="font-serif-display text-2xl leading-tight">{t?.name || "—"}</div>
              {t?.desc && <p className="text-xs text-foreground/60 mt-2 uppercase tracking-widest">{t.desc}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
